// Kart Hareketleri penceresi kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.creditCardTransactions';

export const creditCardTransactionsGuide = (t: TFunction): GuideContent => ({
  layout: 'dialog',
  title: t(`${G}.title`, 'Kart hareketleri nasıl okunur?'),
  intro: t(`${G}.intro`, 'Bir kredi kartının tüm harcama ve ödemelerini sırayla gösterir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    body: t(`${G}.regions.body`, 'Limit ve hareket listesi'),
    footer: t(`${G}.regions.footer`, 'Kapat'),
  },
  steps: [
    {
      region: 'body',
      title: t(`${G}.s1.title`, '1. Limit durumunu okuyun'),
      text: t(`${G}.s1.text`, 'Üstteki satırda kartın Limit, Kullanılan (güncel borç) ve Kalan tutarı görünür. Kalan = Limit − Kullanılan.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Hareketleri okuyun'),
      text: t(`${G}.s2.text`, 'Tip sütununda "Harcama" borcu artıran (+), "Ödeme" borcu azaltan (−) hareketi gösterir. Sonraki Borç, o hareketten sonra kartta kalan borçtur. Projeye bağlı hareketlerde proje adı açıklamanın yanında etiket olarak görünür.'),
      tips: [
        t(`${G}.s2.tip1`, 'Liste uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına satır sayısını seçin.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Hatalı hareketi silin'),
      text: t(`${G}.s3.text`, 'İşlem sütunundaki çöp kutusu hareketi siler; silmeden önce onay istenir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Harcama silinirse kartın borcu bu tutar kadar azalır.'),
        t(`${G}.s3.tip2`, 'Ödeme silinirse kart borcu geri eklenir; ödeme kasadan / bankadan yapıldıysa tutar kaynağa iade edilir.'),
        t(`${G}.s3.tip3`, 'Cariye yapılan kart ödemeleri cari harekete bağlıdır; buradan silinemez, cari hareketlerden silinmelidir.'),
        t(`${G}.s3.tip4`, 'Şube yöneticisi hareket silemez; bu durumda İşlem sütunu görünmez.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s4.title`, '4. Kapatın'),
      text: t(`${G}.s4.text`, '"Kapat" ile pencereden çıkın. Bir hareketi sildiyseniz kart listesi kendiliğinden güncellenir. Başlıktaki (i) bu rehberi yeniden açar.'),
    },
  ],
});
